import $ from 'jquery';

// Button line wiggle animation
export default (container = document) => {
  $('.Button:not(.Button--narrow):not(.Announcement__button):not(.Order__button)', container).each((i, button) => {
    const $button = $(button);
    const outerWidth = 100;
    const outerHeight = 11;

    if (!$button.find('svg.Button__line-strike').length && !$button.hasClass('no-shake')) {
      $button.append(`
        <svg style="width: ${outerWidth}px" class="svg Button__line-strike" data-angled-line="" data-responsive="" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" xml:space="preserve">
          <g><polygon class="line-polygon" points="-1.25,9.25 1.75,${outerHeight} ${outerWidth},1.25 ${outerWidth},3.25"></polygon></g>
        </svg>`);
    }
  });
};